import {
  useInfiniteQuery,
  UseInfiniteQueryOptions,
} from '@tanstack/react-query'
import { PageResponse } from '@core/entities/pagination'
import { CheckInSession, ICheckInSession } from '@core/entities/checkIn'
import { usePageableQuery } from '@core/react-query/hooks'
import { checkInKeys, RequestTypes } from '@core/react-query/features/checkIn'

const dataTransformer = (response: PageResponse<ICheckInSession>) => {
  return {
    ...response,
    content: response.content.map((session) => CheckInSession.new(session)),
  }
}

export const useGetOpenCheckInSessions = (
  payload: RequestTypes['getOpenCheckInSessions'],
  options?: UseInfiniteQueryOptions<
    PageResponse<ICheckInSession>,
    string,
    PageResponse<CheckInSession>
  >,
) => {
  const openSessionsQuery = checkInKeys.openSessions(payload)
  const infiniteQueryOptions = usePageableQuery({
    queryEnabled: options?.enabled,
    queryKey: openSessionsQuery.queryKey,
    dataTransformer,
  })

  return useInfiniteQuery<
    PageResponse<ICheckInSession>,
    string,
    PageResponse<CheckInSession>
  >({
    ...openSessionsQuery,
    ...infiniteQueryOptions,
    ...options,
  })
}
